
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { useEffect } from 'react';
import BaseLayout, { BaseModelProps } from 'src/components/layouts/BaseLayout';
import smoothscroll from 'smoothscroll-polyfill';

import LegalDrawer from 'src/components-pages/legal/LegalDrawer';
import LegalProvider from 'src/components-pages/legal/LegalProvider';
import LegalScrollText from 'src/components-pages/legal/LegalScrollText';
import LegalSeo from 'src/components-pages/legal/seo/Legal.seo';
import { GetStaticProps } from 'next';
import { getBaseModels } from 'src/graphql/models/query';

interface Props extends BaseModelProps {}

function Legal({ baseData }: Props) {
    useEffect(() => {
        smoothscroll.polyfill();
    }, []);
    return (
        <BaseLayout variant="dark" hasFooter baseData={baseData}>
            <LegalSeo />
            <LegalProvider>
                <LegalDrawer />
                <LegalScrollText />
            </LegalProvider>
        </BaseLayout>
    );
}

 const _getStaticProps: GetStaticProps = async () => {
    const baseData = await getBaseModels();
    return {
        props: { baseData },
        revalidate: 100
    };
};

export default Legal;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/legal/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  